import { ca } from '@cian/analytics';

export function trackOnPrevStepButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Profile_user_comm_popup',
    action: 'Click',
    label: 'Prev_step',
  });
}
